import { Injectable } from "@angular/core";
import { MatLegacyDialog } from "@angular/material/legacy-dialog";
import { TaskEditComponent } from "./task-edit/task-edit.component";
import { CtWebapiGenericResponse } from "@ctsolution/ct-webapi";
import { TaskLeadEditComponent } from "./task-lead-edit/task-lead-edit.component";
import { TaskLeadEditConfiguration } from "./task-lead-edit/task-lead-edit.configuration";

@Injectable()

export class TaskService {

    constructor(private dialog: MatLegacyDialog) { }

    createTaskLead(taskLeadConfiguration : TaskLeadEditConfiguration) {

        return new Promise<any | null>(resolve => {
            this.dialog.open(TaskLeadEditComponent, {
                data: taskLeadConfiguration, maxWidth: '800px', minWidth: '500px'
            })
                .afterClosed()
                .subscribe((response: CtWebapiGenericResponse<any> | null) => {

                    const result = { Oid: response?.Result };
                    resolve(result)

                });
        });
    }

}